import TaskStatusService from "../TaskStatus/TaskStatus.service";
export default class TaskService {
    static fromJSON(json) {
        return Object.assign(Object.assign({}, json), { startDate: json.startDate && new Date(json.startDate), dueDate: json.dueDate && new Date(json.dueDate), createdDate: new Date(json.createdDate), modifiedDate: new Date(json.modifiedDate), assignedDate: new Date(json.assignedDate), statusModifiedDate: new Date(json.statusModifiedDate) });
    }
    static isOverdue(task) {
        // If the task is not completed or cancelled, then check to see if the due date exists and is greater than today.
        return (![
            TaskStatusService.Completed.id,
            TaskStatusService.Cancelled.id,
        ].includes(task.status.id) &&
            !!task.dueDate &&
            new Date() > task.dueDate);
    }
    static isActive(task) {
        return (![
            TaskStatusService.Completed.id,
            TaskStatusService.Cancelled.id,
        ].includes(task.status.id) &&
            (!task.startDate || task.startDate < new Date()));
    }
}
